const customSelectors = {};
class customJS {
    constructor() {
        let self = this
        var elementToObserve = document.querySelector('.page-content');
        if (elementToObserve != null) {
            const observer = new MutationObserver(function () {
                observer.disconnect();
                self._quickView();
                if (document.querySelector('[data-parent-promo-card]') != null) {
                    _replacePromoBlock();
                }
                setTimeout(function () {
                    observer.observe(elementToObserve, { childList: true, subtree: true });
                }, 400)

            });
            observer.observe(elementToObserve, { childList: true, subtree: true });
        }

    }
    _quickView = () => {
        document.querySelectorAll(".snize-quick-view-button").forEach(element => {
            element.onclick = (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let handle = element.closest('a').getAttribute('href');
                const handle_product = handle.split("/");
                let product_handle = handle_product.slice(-1)[0]
                element.className += " quickshop--button"
                element.setAttribute('data-handle', product_handle)
                document.querySelector('[data-searchanise_quickshop]').setAttribute('data-handle', product_handle)
                document.querySelector('[data-searchanise_quickshop]').click();
            }
        })
    }
}



typeof customJS !== 'undefined' && new customJS();

